// extracted by mini-css-extract-plugin
export default {"title":"SpecialRequestDetails_title__-hE+L","total":"SpecialRequestDetails_total__CcS9u","edit":"SpecialRequestDetails_edit__K42Mo"};